// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: -5%;
  padding-bottom: 5%;
  border-radius: 8px;
  margin-bottom: 4%;
  position: relative;
  margin-left: -80% !important;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.pagination-button {
  padding: 5px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.pagination-button:disabled {
  background-color: #f0f0f0;
  color: #999;
  cursor: not-allowed;
}

.pagination-button:hover:not(:disabled) {
  background-color: #0C3135;
  color: white;
}

.pagination-info {
  font-size: 16px;
  color: #0C3135;
  margin-left: -7px;
}

.pagination-input {
  width: 40px !important;
  height: 28px;
  padding: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  outline: none;
  background-color: #fff;
  color: #333;
  margin: 0 5px;
}

.records-per-page-container {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  right: 25%;
  flex-direction: row; 
}

.records-per-page-dropdown {
  width: 70px;
  height: 28px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  outline: none;
  cursor: pointer;
  order: 2;
}

.dropdown-label {
  font-size: 14px;
  color: #0C3135;
  white-space: nowrap;
  line-height: 28px;
  order: 1; 
  margin-right: 8px;
}
@media (max-width: 321px) {
  .pagination-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -5%;
    margin-left: 5%;
    padding: 0;
    gap: 15px;
    position: static;
  }

  .pagination-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 20%;
    order: 1;
  }

  .pagination-button {
    padding: 4px 8px;
    font-size: 12px;
    min-width: 30px;
  }

  .pagination-input {
    width: 10px !important;
    height: 20px;
    font-size: 10px;
    margin: 0 2px;
  }

  .pagination-info {
    font-size: 12px;
    margin-left: 0;
  }

  .records-per-page-container {
    position: static;
    width: 20%;
    justify-content: center;
    order: 2;
    margin-top: -2%;
  }

  .records-per-page-dropdown {
    width: 45px;
    height: 25px;
    font-size: 12px;
    padding: 2px;
  }

  .dropdown-label {
    font-size: 12px;
    line-height: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceInventoryDashboard/Pagination.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["\n.pagination-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: -5%;\n  padding-bottom: 5%;\n  border-radius: 8px;\n  margin-bottom: 4%;\n  position: relative;\n  margin-left: -80% !important;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.pagination-button {\n  padding: 5px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #333;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.pagination-button:disabled {\n  background-color: #f0f0f0;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.pagination-button:hover:not(:disabled) {\n  background-color: #0C3135;\n  color: white;\n}\n\n.pagination-info {\n  font-size: 16px;\n  color: #0C3135;\n  margin-left: -7px;\n}\n\n.pagination-input {\n  width: 40px !important;\n  height: 28px;\n  padding: 4px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n  outline: none;\n  background-color: #fff;\n  color: #333;\n  margin: 0 5px;\n}\n\n.records-per-page-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: absolute;\n  right: 25%;\n  flex-direction: row; \n}\n\n.records-per-page-dropdown {\n  width: 70px;\n  height: 28px;\n  padding: 4px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  font-size: 14px;\n  color: #333;\n  outline: none;\n  cursor: pointer;\n  order: 2;\n}\n\n.dropdown-label {\n  font-size: 14px;\n  color: #0C3135;\n  white-space: nowrap;\n  line-height: 28px;\n  order: 1; \n  margin-right: 8px;\n}\n@media (max-width: 321px) {\n  .pagination-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: -5%;\n    margin-left: 5%;\n    padding: 0;\n    gap: 15px;\n    position: static;\n  }\n\n  .pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    width: 20%;\n    order: 1;\n  }\n\n  .pagination-button {\n    padding: 4px 8px;\n    font-size: 12px;\n    min-width: 30px;\n  }\n\n  .pagination-input {\n    width: 10px !important;\n    height: 20px;\n    font-size: 10px;\n    margin: 0 2px;\n  }\n\n  .pagination-info {\n    font-size: 12px;\n    margin-left: 0;\n  }\n\n  .records-per-page-container {\n    position: static;\n    width: 20%;\n    justify-content: center;\n    order: 2;\n    margin-top: -2%;\n  }\n\n  .records-per-page-dropdown {\n    width: 45px;\n    height: 25px;\n    font-size: 12px;\n    padding: 2px;\n  }\n\n  .dropdown-label {\n    font-size: 12px;\n    line-height: 25px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
